import React, { useState, useEffect, memo } from 'react';
import { FaCookie, FaTimes } from 'react-icons/fa';
import { IconWrapper } from './IconWrapper';

const CookieConsent: React.FC = memo(() => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Небольшая задержка для лучшего UX
      setTimeout(() => setShow(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShow(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 lg:left-64 z-50 p-4 animate-slide-up">
      <div className="max-w-7xl mx-auto bg-white rounded-xl shadow-2xl border border-gray-200 p-6">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          <div className="flex items-center space-x-3 flex-1">
            <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0">
              <IconWrapper icon={FaCookie} className="text-primary-600" size={24} />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">
                Nous utilisons des cookies
              </h3>
              <p className="text-sm text-gray-600">
                Ce site utilise des cookies pour améliorer votre expérience de navigation et analyser 
                le trafic. En continuant, vous acceptez notre utilisation des cookies. 
                <a 
                  href="/politique-cookies" 
                  className="text-primary-600 hover:text-primary-700 ml-1 underline"
                >
                  En savoir plus
                </a>
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3 w-full md:w-auto">
            <button
              onClick={handleReject}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Refuser
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2 text-sm font-medium text-white bg-primary-600 rounded-lg hover:bg-primary-700 transition-colors"
            >
              Accepter
            </button>
            <button
              onClick={handleReject}
              className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="Fermer"
            >
              <IconWrapper icon={FaTimes} size={20} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});

CookieConsent.displayName = 'CookieConsent';

export default CookieConsent;

